import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Login } from './components/Login';
import { Dashboard } from './components/Dashboard';
import { ExerciseForm } from './components/ExerciseForm';
import { ExerciseWizard } from './components/ExerciseWizard';
import { ExerciseView } from './components/ExerciseView';
import { PreviewEdit } from './components/PreviewEdit';

// Protected Route Component
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }
  
  return user ? <>{children}</> : <Navigate to="/login" />;
};

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route 
        path="/login" 
        element={user ? <Navigate to="/" /> : <Login />} 
      />
      <Route 
        path="/" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/exercises/new" 
        element={
          <ProtectedRoute>
            <ExerciseWizard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/exercises/advanced" 
        element={
          <ProtectedRoute>
            <ExerciseForm />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/exercises/:id" 
        element={
          <ProtectedRoute>
            <PreviewEdit />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/exercises/:id/legacy" 
        element={
          <ProtectedRoute>
            <ExerciseView />
          </ProtectedRoute>
        } 
      />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
